import React, { ComponentProps, useState } from "react";
import { cls } from "@wss/cls";
import { Button, Icon } from "@clarkinc/zest-design-system/ui";
import { prepend } from "~/features/utility/tailwindUtils";

// Do not use this component as a reference - it contains hacks to make things work
const StickyHeader = ({
  className,
  children
}: ComponentProps<"div">) => {
  const [open, setOpen] = useState(true);
  if (!open) {
    return <Button variant="plain" id="sh-show-quick-links" type="button" className={cls("z-1000 fixed right-7 top-0 px-2 pb-1 pt-2 bg-white text-white text-xs leading-[14px] text-center transition-all duration-200 rounded rounded-t-none shadow-md", prepend({
      before: "absolute bg-gray-900 opacity-0 p-1 content-['Show_Quick_Links'] top-1-1/4 right-10 w-26 rounded",
      "hover:before": "opacity-80 [animation:fadeInDown_0.2s]",
      hover: "pt-3"
    }), className)} onClick={() => setOpen(true)}>
        <span className="sr-only">Show Quick Links</span>
        <Icon name="ri-arrow-down-s-fill" className="w-5 h-5" />
      </Button>;
  }
  const [detailsSlot, pricingSlot, navigationSlot] = React.Children.toArray(children);
  return <div className={cls("wss fixed top-0 left-0 w-full z-40 bg-white shadow-lg transition-all duration-150", className)} data-sentry-component="StickyHeader" data-sentry-source-file="StickyHeader.tsx">
      <div className="container py-2 flex justify-between">
        {detailsSlot}
        {pricingSlot}

        <Button variant="plain" aria-label="hide quick links" id="sh-hide-quick-links" type="button" className={cls("h-10 ml-2 opacity-50 text-xs leading-[14px] text-center transition-all duration-200", prepend({
        lz: "absolute right-1 top-3",
        before: "content-['Hide_Quick_Links'] opacity-0 bg-gray-900 text-white p-1 rounded",
        "hover:before": "opacity-80 [animation:fadeInDown_0.2s]",
        hover: "opacity-75"
      }))} onClick={() => setOpen(false)} data-sentry-element="Button" data-sentry-source-file="StickyHeader.tsx">
          <span className="sr-only">Hide Quick Links</span>
          <Icon name="ri-close-line" className="w-8 h-8" aria-hidden="true" data-sentry-element="Icon" data-sentry-source-file="StickyHeader.tsx" />
        </Button>
      </div>

      <div className="border-0 border-t border-gray-200 border-solid">
        {navigationSlot}
      </div>
    </div>;
};
export default StickyHeader;